import React, {useState} from "react";
import Carousel, {autoplayPlugin, Dots} from "@brainhubeu/react-carousel";

import {Image} from "../common/image/Image";

import "@brainhubeu/react-carousel/lib/style.css";
import "./InfoSlider.css";
import {useSelector} from "react-redux";
import {settingSelectors} from "./_core/settingSelectors";

const PRODUCT_SLIDE_ANCHOR = /(?:^|\/|#)(rollset|dessert|bento|poke|soup|drink|warmer|roll)-(\d+)$/i;

const toSlideHref = (link) => {
    if (!link) {
        return null;
    }
    const match = String(link).trim().match(PRODUCT_SLIDE_ANCHOR);
    if (match) {
        return `#${match[1].toLowerCase()}-${match[2]}`;
    }
    return link;
};

const scrollToProductAnchor = (event, href) => {
    event.preventDefault();
    const element = document.getElementById(href.replace('#', ''));
    if (element) {
        element.scrollIntoView({behavior: 'smooth', block: 'start'});
    }
};

const prepareSlides = (slides) => slides.valueSeq().toArray()
    .sort((a, b) => a.get('position') > b.get('position') ? 1 : -1)
    .map(slide => {
        const href = toSlideHref(slide.get('link'));
        const isProductAnchor = href && href.startsWith('#') && PRODUCT_SLIDE_ANCHOR.test(href);
        return (
            <div key={'slide-' + slide.get('id')}>
                {href ? (
                    <a href={href}
                       target={isProductAnchor ? '_self' : (slide.get('linkTarget') || '_self')}
                       onClick={isProductAnchor ? (event) => scrollToProductAnchor(event, href) : undefined}>
                        <Image type="main" publicImages={slide.publicImages}/>
                    </a>
                ) : (
                    <Image type="main" publicImages={slide.publicImages}/>
                )}
            </div>
        );
    })

export const InfoSlider = () => {
    const slides = useSelector(settingSelectors.slides);
    const [state, setState] = useState({
        value: 0,
        slides: prepareSlides(slides)
    });
    const onchange = (value) => {
        if (state.value !== value && !isNaN(value)) {
            setState({
                value: value,
                slides: state.slides
            })
        }
    };

    if (!slides || slides.size === 0) {
        return null;
    }
    const plugins = slides.size > 1 ? [
        'infinite',
        {
            resolve: autoplayPlugin,
            options: {
                interval: 10000,
            }
        },
    ] : []


    return (
        <div className="hide-on-4cards" data-type="slider">
            <div className="main-slider">
                <div className="main-slider-area">
                    <div className="main-slider-area__item">
                        <Carousel plugins={plugins} value={state.value} slides={state.slides} onChange={onchange}/>
                        <Dots value={state.value} onChange={onchange} number={slides.size}/>
                    </div>
                </div>
            </div>
        </div>
    );
};
